import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

function WorkflowStateBadge (props) {
  const { workflow } = props
  if (!workflow) {
    return <div className="badge my-badge-status badge-light">確認中</div>
  } else if (workflow.is_returned) {
    return <div className="badge my-badge-status badge-danger">差戻し</div>
  } else if (workflow.is_approved) {
    return <div className="badge my-badge-status badge-primary">承認済</div>
  } else {
    return <div className="badge my-badge-status badge-light">確認中</div>
  }
}

WorkflowStateBadge.propTypes = {
  workflow: PropTypes.object
}

export default function renderWorkflowStateBadge (element = null) {
  const elem = element ? $(element).find('.workflow-state-badge') : $('.workflow-state-badge')
  elem.each((i, el) => {
    const qel = $(el)
    const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる

    ReactDOM.render(<WorkflowStateBadge {...props}/>, el)

    Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
      qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
      return 0
    })
  })
}
